import { getBIC as getBicInternal } from "bic-from-iban";
export var getBic = function (iban) {
    var result = getBicInternal(iban);
    if (result) {
        return result;
    }
    return "Unknown bic";
};
